module.exports = __webpack_public_path__ + "img/3.00505d93.svg";